<template>
  <div class="container py-4 my-4 my-md-10">
    <div id="finance-calculator-section" class="row gx-3">
      <div class="col-lg-8 mb-lg-5">
        <h2>Informatie</h2>
        <p>Alle opties, specificaties en accessoires van deze prachtige {{ car.title }}</p>
        <h3 class="h5 mt-4">Specificaties</h3>
        <div class="row gx-3 gy-4">
          <div class="col-sm-4" v-for="(item) in fieldOptions.slice(0, 9)" v-bind:key="item.key">
            <div class="col-sm-4">
              {{ item.title }}
            </div>
            <!-- Voor het kenteken -->
            <p class="fw-bold" v-if="item.key === 'kenteken'">
              <span v-if="car.extradata[item.key] && isValidPlate(car.extradata[item.key])">
                  {{ car.extradata[item.key] }}
              </span>
                    <span v-else>
                  n.t.b.
              </span>
            </p>

            <!-- Voor BTW/Marge -->
            <p class="fw-bold" v-else-if="item.key === 'btw_marge'">
              <span v-if="car.extradata[item.key] === 'B'">BTW</span>
              <span v-else-if="car.extradata[item.key] === 'M'">Marge</span>
            </p>

            <!-- Voor alle andere keys behalve kenteken en btw_marge -->
            <p class="fw-bold" v-else-if="car.extradata[item.key] && item.key !== 'btw_marge'">
              <span v-html="(item.prefix ?? '') + ' ' +(translateDict[car.extradata[item.key]] ?? car.extradata[item.key]) + ' ' +(item.suffix ?? '')"></span>
            </p>
          </div>
        </div>
        <button type="button" class="btn mt-4" data-bs-toggle="modal" data-bs-target="#carInfoModal" @click="$emit('setActiveTab', 'carInfo-tab-1')">Bekijk alle specificaties</button>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0">
        <div v-if="car.extradata.finance_term" id="financiering-berekenen" v-html="car.iframe_code"></div>
        <div v-if="!car.extradata.finance_term" v-bind:style="{ 'background-image': 'url(' + contact.photo + ')' }" style="background-size: cover;" class="col-inner p-3 p-md-5 crc-side-imgbg d-flex flex-column justify-content-end align-items-start h-100 crc-shadow">
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['car', 'fieldOptions', 'contact','locations'],
  data() {
    return {
      translateDict: {
        "j":"Nieuw",
        "n":"Occasion",
        "B":"Benzine",
        "D":"Diesel",
        "B,E":"Benzine & Elektrisch",
        "D,E":"Diesel & Elektrisch",
        "E":"Elektrisch",
        "H":"Handgeschakeld",
        "A":"Automaat",
        "C":"Automaat",
      },
    }
  },
  methods: {
    isValidPlate(plate) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/;
      return regex.test(plate);
    },
    scrollToSection() {
      this.$refs['financiering-berekenen'].scrollIntoView({ behavior: "smooth" });
    }
  }

}
</script>
<style lang="scss" scoped>
.crc-car-component-container {
  .crc-single-car-hero .col-inner {
    border-radius: 4px;
    background-color: white;
  }

  .crc-imgslider {
    .crc-img-container {
      height: 700px;
    }
  }

  .crc-imgslider-nav {
    .crc-img-container {
      height: 100px;
      width: 14%;
    }
  }

  .crc-buttons {
    margin: 0 -6px;
    display: flex;
    flex-wrap: wrap;

    .btn {
      width: calc(100% - 12px);
      margin: 6px;

      &.half {
        width: calc(50% - 12px);
      }
    }
  }

  .crc-reffer-cards {
    .crc-reffer-card-img-head {
      position: relative;

      .crc-img-container {
        height: 200px;

        &.person {
          position: absolute;
          bottom: -20px;
          left: 48px;
          width: 100px;
          height: 100px;
          border-radius: 100px;
        }
      }
    }

    .crc-reffer-card-body {
      background-color: white;

      a.btn {
        width: 100%;
      }
    }
  }
}
</style>
